import React from "react";
import AccordionFooter from "./AccordionFooter";
import { HashLink } from "react-router-hash-link";
import bgfooter from "assets/img/bgfooter.png";
import organic from "assets/img/organic.png";
import cards from "assets/img/cards.png";
import newlogo from "assets/img/newlogo.png";
import iptlogo from "assets/img/IPT Logo.png";
export default function Footer() {
  const accordionData = [
    {
      title: "Quick Links",
      content: [
        <ul key="list">
          <li className="text-base text-black py-2">
            <a href="/homepage1">Home</a>
          </li>
          <li className="text-base font py-2">
            <a href="/about-us">About Us</a>
          </li>
          <li className="text-base font py-2">
            <a href="/product">Product</a>
          </li>
          <li className="text-base font py-2">
            <a href="/service">Services </a>
          </li>


          <li className="text-base font py-2">
            <a href="/contact">Contact Us</a>
          </li>
        </ul>,
      ],
    },

    {
      title: "Products",
      content: [
        <ul key="list">
          <li className="text-base font py-2">
            <a href="/product">Silos</a>
          </li>
          <li className="text-base font py-2">
            <a href="/product">Storage Tanks</a>
          </li>
          <li className="text-base font py-2">
            <a href="/product">Incubation Tanks </a>
          </li>
          <li className="text-base font py-2">
            <a href="/product">Butter Melting Tanks</a>
          </li>
          <li className="text-base font py-2">
            <a href="/product">Ribbon Blenders</a>
          </li>
        </ul>,
      ],
    },

    {
      title: "Services",
      content: [
        <ul key="list">
          <li className="text-base font py-2">
            <a href="/service">Dairy Plant</a>
          </li>
          <li className="text-base font py-2">
            <a href="/service">Juice</a>
          </li>
          <li className="text-base font py-2">
            <a href="/service">Beverages </a>
          </li>
          <li className="text-base font py-2">
            <a href="/service">Cheese Plants</a>
          </li>
          <li className="text-base font py-2">
            <a href="/service">Chocolate & Sweets</a>
          </li>
        </ul>,
      ],
    },

    {
      title: "Address ",
      content: [
        <ul key="list">
          <li className="text-base font py-2">
            <a href="/homepage1">
              <span className="text-blue">UAE : </span>  00971 50 633 0106
            </a>
          </li>
          <li className="text-base font py-2">
            <a href="/homepage1">
              <span className="text-blue">India : </span> 91 81389 44380 |  91 460 280 0819
            </a>
          </li>
          <li className="text-base font py-2">
            <a href="/homepage1">
              info@innovativeprocesstechnologies.com
            </a>
          </li>
        </ul>,
      ],
    },




  ];

  return (
    <>
      <footer className=" xl:hidden lg:hidden md:block sm:block block">
        <div
          className="xl:hidden lg:hidden md:block block sm:block md:pt-12 md:pb-12 pt-10 pb-8 poppins"
          style={{
            backgroundImage: `url(${bgfooter})`,
            width: "100%",
          }}
        >
          <div className="app px-4">
            {accordionData.map((item, index) => (
              <AccordionFooter
                key={index}
                title={item.title}
                content={item.content}
              />
            ))}
            <div className="mt-4">
              <div>
                <p className="text-black text-base text-center">
                  ©2025,{" "}
                  <span className="font-bold text-black">
                    Innovative Process Technologies
                  </span>{" "}
                  All Rights Reserved.
                </p>
              </div>
              <div class="flex justify-center items-center gap-4 mt-4">
                <a href="#" class="text-black text-xl">
                  <i class="fab fa-facebook-f"></i>
                </a>
                <a href="#" class="text-black text-xl">
                  <i class="fab fa-linkedin"></i>
                </a>
                <a href="#" class="text-black text-xl">
                  <i class="fab fa-twitter"></i>
                </a>
                <a href="#" class="text-black text-xl">
                  <i class="fab fa-instagram"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <section className="poppins xl:block lg:block md:hidden sm:hidden hidden ">
        <div
          className="xl:pt-20 xl:pb-20 lg:pt-20 lg:pb-16"
          style={{
            backgroundImage: `url(${bgfooter})`,
            width: "100%",
          }}
        >
          <div>
            <div class="container mx-auto  xl:px-0 px-4">
              <div class="flex justify-between text-gray-700">
                <div className="xl:w-3/12 lg:w-3/12">
                  <div>
                    <img
                      className="xl:w-12/12 lg:w-10/12 xl:-mt-12 xl:-ml-14 lg:-mt-6 lg:-ml-8"
                      src={iptlogo}
                      alt=""
                    />
                  </div>
                  <p className="xl:text-sm text-sm text-para ">
                    A New Venture to Manufacture Process Plants to support
                    Farmers for Transforming their Agricultural products to a
                    high value added Durable product.
                  </p>
                  <div class="flex xl:gap-4 lg:gap-2 gap-4 xl:mt-4 lg:mt-4">
                    <a
                      href="#"
                      class=" box bg-white h-10 w-10 flex items-center justify-center rounded-full text-blue borderblue"
                    >
                      <i class="fab fa-facebook-f"></i>
                    </a>
                    <a
                      href="#"
                      class="box bg-white h-10 w-10 flex items-center justify-center rounded-full text-blue borderblue"
                    >
                      <i class="fab fa-twitter"></i>
                    </a>
                    <a
                      href="#"
                      class="box bg-white h-10 w-10 flex items-center justify-center rounded-full text-blue borderblue"
                    >
                      <i class="fab fa-youtube"></i>
                    </a>
                    <a
                      href="#"
                      class="box bg-white h-10 w-10 flex items-center justify-center rounded-full text-blue borderblue"
                    >
                      <i class="fab fa-instagram-square"></i>
                    </a>
                  </div>
                </div>

                <div>

                  <ul class="space-y-2 xl:mt-2 mt-2">
                    <li className="textt text-base font-semibold text-black">
                      <a href="#">Quick Links</a>
                    </li>
                    <li className="textt text-sm text-para xl:mt-4 mt-4">
                      <a href="/homepage1">Home</a>
                    </li>
                    <li className="textt text-sm text-para xl:mt-4 mt-4">
                      <a href="/about-us">About Us</a>
                    </li>
                    <li className="textt text-sm text-para xl:mt-4 mt-4">
                      <a href="/product">Product</a>
                    </li>
                    <li className="textt text-sm text-para xl:mt-4 mt-4">
                      <a href="/service">Services</a>
                    </li>
                    <li className="textt text-sm text-para xl:mt-4 mt-4">
                      <a href="/contact">Contact</a>
                    </li>

                  </ul>
                </div>

                {/* <div>
                  <ul class="space-y-2 xl:mt-2 mt-2">
                    <li className="textt text-base font-semibold text-black">
                      <a href="#">Products</a>
                    </li>
                    <li className="textt text-sm text-para xl:mt-4 mt-4">
                      <a href="#">Silos</a>
                    </li>
                    <li className="textt text-sm text-para xl:mt-4 mt-4">
                      <a href="#">Storage Tanks</a>
                    </li>
                    <li className="textt text-sm text-para xl:mt-4 mt-4">
                      <a href="#">Incubation Tanks</a>
                    </li>
                    <li className="textt text-sm text-para xl:mt-4 mt-4">
                      <a href="#">Butter Melting Tanks</a>
                    </li>
                    <li className="textt text-sm text-para xl:mt-4 mt-4">
                      <a href="#">Ribbon Blenders</a>
                    </li>
                  </ul>
                </div> */}

                <div>
                  <ul class="space-y-2 xl:mt-2 mt-2">
                    <li className="textt text-base font-semibold text-black">
                      <a href="#">Services</a>
                    </li>
                    <li className="textt text-sm text-para xl:mt-4 mt-4">
                      <a href="#">Dairy Plant</a>
                    </li>
                    <li className="textt text-sm text-para xl:mt-4 mt-4">
                      <a href="#">Juice</a>
                    </li>
                    <li className="textt text-sm text-para xl:mt-4 mt-4">
                      <a href="#">Beverages</a>
                    </li>
                    <li className="textt text-sm text-para xl:mt-4 mt-4">
                      <a href="#">Cheese Plants</a>
                    </li>
                    <li className="textt text-sm text-para xl:mt-4 mt-4">
                      <a href="#">Chocolate & Sweets</a>
                    </li>
                  </ul>
                </div>

                <div>
                  <p class="textt text-base font-semibold text-black xl:mt-2 mt-2">
                    Address
                  </p>
                  <div class="flex items-center gap-4 xl:mt-4 mt-4">
                    <i class="fas fa-phone-alt text-blue"></i>
                    <span className=" xl:text-base  text-sm  text-para">
                      <span className="text-blue text-base">UAE : </span> 00971 50 633 0106
                    </span>
                  </div>
                  <div class="flex items-center gap-4 xl:mt-2 mt-2">
                    <i class="fas fa-phone-alt text-blue scale-x-[-1]"></i>
                    <span className="xl:text-base text-sm  text-para">
                      <span className="text-blue">India : </span> 91 81389 44380 | 91 460 280 0819
                    </span>
                  </div>
                  <div class="flex items-center gap-4 xl:mt-2 mt-2">
                    <i class="fas fa-envelope text-blue"></i>
                    <span className=" xl:text-base text-sm  text-para">
                      info@innovativeprocesstechnologies.com
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div className="container mx-auto xl:pt-28 lg:pt-8 xl:px-0 px-4">
              <div className="bg-white rounded-md py-6 px-6 shadow-xl">
                <div className="flex justify-center">
                  <div>
                    <p className="text-black text-base">
                      ©2025,{" "}
                      <span className="font-bold text-black">
                        Innovative Process Technologies
                      </span>{" "}
                      All Rights Reserved.
                    </p>
                  </div>

                  {/* <div>
                    <div className="flex">
                      <div>
                        <h1>We accept :</h1>
                      </div>

                      <div>
                        <img className="mt-1" src={cards} alt="" />
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
